import { useEffect, useState } from "react";
import axios from "axios";
import ReusableDataTable from "../../hooks/ReusableDataTable";

function IncompleteCuttingDcSection({ selectedBuyer, selectedOrder, selectedSubOrder }) {
  const [incompleteList, setIncompleteList] = useState([]);

  useEffect(() => {
    const buyerParam = selectedBuyer !== "All Buyers" ? `&buyer_id=${selectedBuyer}` : "";
    const orderParam = selectedOrder !== "All Orders" ? `&order_id=${selectedOrder}` : "";
    const subOrderParam = selectedSubOrder !== "All Sub Orders" ? `&sub_order_id=${selectedSubOrder}` : "";

    axios
      .get(`dashboard/incomplete-cuttingdc?${buyerParam}${orderParam}${subOrderParam}`)
      .then((res) => {
        setIncompleteList(res.data);
      })
      .catch((err) => {
        console.error("Error fetching incomplete Cutting DC data", err);
      });
  }, [selectedBuyer, selectedOrder, selectedSubOrder]);

  const columns = [
    { name: "Buyer", selector: (row) => row.buyer_name || "-", sortable: true },
    { name: "Order No", selector: (row) => row.cut_order_no || "-", sortable: true },
    { name: "Colour", selector: (row) => row.colour || "-", sortable: true },
    { name: "Total Pieces", selector: (row) => row.total_piece, sortable: true },
  ];

  return (
    <div className=" p-4 bg-white rounded shadow-md">
      <h2 className="text-xl font-bold text-red-600 ">Cutting Stock</h2>
      {incompleteList.length === 0 ? (
        <p className="text-gray-500">All Cutting DCs are up to date.</p>
      ) : (
        <ReusableDataTable
          columns={columns}
          data={incompleteList}
          pagination
          highlightOnHover
          dense
        />
      )}
    </div>
  );
}

export default IncompleteCuttingDcSection;
